import { computed } from 'vue';
import type { SkinDestination } from 'data-types-config';

/**
 * useSkinDestinationHoverOverride - Logic for handling dynamic hover colors specifically for link skins.
 */
export default function useSkinDestinationHoverOverride(
  props: Partial<SkinDestination>,
) {
  const hoverOverrideValue = computed(() => {
    const hoverColor = props.hoverColor;
    if (!hoverColor || typeof hoverColor !== 'string') return hoverColor;
    return hoverColor.startsWith('var:')
      ? hoverColor.replace(/^var:/, 'var(--ti-') + ')'
      : hoverColor;
  });

  const hoverOverrideClass = computed(() =>
    props.hoverColor ? 'has-hover-override' : '',
  );

  return {
    hoverOverrideValue,
    hoverOverrideClass,
  };
}
